import type { ParseKeys } from 'i18next';
import type { components } from '@/api/qraft/schema';

// Translation keys, translated where shown. Kept out of QuestionEditor so the
// questions list's validateSearch doesn't pull the rich text editor into the
// public entry chunk.
export const QUESTION_TYPE_LABELS = {
  choose_one: 'admin.questionEditor.type.chooseOne',
  choose_multiple: 'admin.questionEditor.type.chooseMultiple',
  fill_in_blank: 'admin.questionEditor.type.fillInBlank',
  essay: 'admin.questionEditor.type.essay',
} as const satisfies Record<components['schemas']['QuestionTypes'], ParseKeys>;
